var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewRejected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99935 18.3337C14.6017 18.3337 18.3327 14.6027 18.3327 10.0003C18.3327 5.39795 14.6017 1.66699 9.99935 1.66699C5.39698 1.66699 1.66602 5.39795 1.66602 10.0003C1.66602 14.6027 5.39698 18.3337 9.99935 18.3337ZM8.65259 7.18042C8.24579 6.77363 7.58624 6.77363 7.17945 7.18042C6.77265 7.58722 6.77265 8.24677 7.17945 8.65356L8.52621 10.0003L7.17945 11.3471C6.77265 11.7539 6.77265 12.4134 7.17945 12.8202C7.58624 13.227 8.24579 13.227 8.65259 12.8202L9.99935 11.4735L11.3461 12.8202C11.7529 13.227 12.4125 13.227 12.8193 12.8202C13.226 12.4134 13.226 11.7539 12.8193 11.3471L11.4725 10.0003L12.8193 8.65356C13.226 8.24677 13.226 7.58722 12.8193 7.18042C12.4125 6.77363 11.7529 6.77363 11.3461 7.18042L9.99935 8.52719L8.65259 7.18042Z",
    fill: "#F4526B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewRejected);
export default __webpack_public_path__ + "static/media/interview-rejected.0fb10fb65f427998fa55c820cc01a2c5.svg";
export { ForwardRef as ReactComponent };